(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gemist-designer"] && !Shopify.designMode) return;
  try {
    

  const baseURL = "https://holden.gemist.co/";
  const gemistOrigin = new URL(baseURL).origin;

  function isDesignerIframeFullscreen(iframe) {
    return (
      document.fullscreenElement === iframe ||
      document.webkitFullscreenElement === iframe ||
      document.mozFullScreenElement === iframe ||
      document.msFullscreenElement === iframe
    );
  }

  function postFullscreenStateToDesignerIframe() {
    var iframe = document.getElementById("designer-iframe");
    if (!iframe || !iframe.contentWindow) {
      return;
    }
    var active = isDesignerIframeFullscreen(iframe);
    var payload = JSON.stringify({type: "fullscreenstate", active: active});
    iframe.contentWindow.postMessage(payload, "*");
  }

// Self-contained mini-cart: the theme's own cart drawer is a Vue/Pinia component with no bridge for
// outside scripts to open it, so instead of depending on the theme's internals (or redirecting to
// /cart), we build and control our own small overlay here, populated straight from /cart.js.
  function gemistEscapeHtml(value) {
    return String(value).replace(/[&<>"']/g, function(c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function gemistFormatMoney(cents) {
    return "$" + (Number(cents || 0) / 100).toFixed(2);
  }

  function gemistRenderMiniCartItem(item) {
    var propsHtml = "";
    if (item.properties) {
      var propLines = [];
      Object.keys(item.properties).forEach(function(key) {
        if (key.indexOf("_") === 0 || key === "gemist") return;
        var value = item.properties[key];
        if (value === null || value === "" || value === undefined) return;
        propLines.push(gemistEscapeHtml(key) + ": " + gemistEscapeHtml(value));
      });
      if (propLines.length) {
        propsHtml = '<p class="gemist-mini-cart-item-props">' + propLines.join(" &middot; ") + "</p>";
      }
    }

    var primaryImage = item.image;
    var fallbackImageRing = item.properties && item.properties._image_ring;
    var fallbackImageDiamond = item.properties && item.properties._image_diamond;
    var fallbackImageGemstone = item.properties && item.properties._image_gemstone;
    var fallbackImage = fallbackImageRing || fallbackImageDiamond || fallbackImageGemstone;
    var imageSrc = primaryImage || fallbackImage;
    var imageHtml = imageSrc
      ? '<img src="' + gemistEscapeHtml(imageSrc) + '" alt="" width="64" height="64"' +
          (primaryImage && fallbackImage
            ? ' onerror="this.onerror=null;this.src=\'' + gemistEscapeHtml(fallbackImage) + '\';"'
            : "") +
        ">"
      : "";

    return (
      '<div class="gemist-mini-cart-item">' +
        imageHtml +
        "<div>" +
          '<p class="gemist-mini-cart-item-title">' +
            gemistEscapeHtml(item.product_title || item.title) + " &times; " + item.quantity +
          "</p>" +
          propsHtml +
          '<p class="gemist-mini-cart-item-price">' + gemistFormatMoney(item.final_line_price) + "</p>" +
        "</div>" +
      "</div>"
    );
  }

  function gemistUpdateHeaderCartBadge(itemCount) {
    var badge = document.querySelector('a[href="/cart"][aria-label="Bag"] span');
    if (badge) badge.textContent = "(" + itemCount + ")";
  }

  function gemistRenderMiniCart(overlay, cart) {
    var itemsHtml = (cart.items || []).map(gemistRenderMiniCartItem).join("");
    overlay.querySelector(".gemist-mini-cart-items").innerHTML =
      itemsHtml || "<p>Your bag is empty.</p>";
    overlay.querySelector(".gemist-mini-cart-subtotal-value").textContent =
      gemistFormatMoney(cart.total_price);
    overlay.querySelector(".gemist-mini-cart-count").textContent = cart.item_count;
    gemistUpdateHeaderCartBadge(cart.item_count);
  }

  function gemistCloseMiniCart() {
    var overlay = document.getElementById("gemist-mini-cart-overlay");
    if (overlay) overlay.classList.remove("is-open");
  }

  function gemistBuildMiniCartOverlay() {
    var overlay = document.createElement("div");
    overlay.id = "gemist-mini-cart-overlay";
    overlay.className = "gemist-mini-cart-overlay";
    overlay.innerHTML =
      '<div class="gemist-mini-cart">' +
        '<div class="gemist-mini-cart-header">' +
          "<h2>Your Bag (<span class=\"gemist-mini-cart-count\">0</span>)</h2>" +
          '<button type="button" class="gemist-mini-cart-close" aria-label="Close bag">&times;</button>' +
        "</div>" +
        '<div class="gemist-mini-cart-items"></div>' +
        '<div class="gemist-mini-cart-footer">' +
          '<div class="gemist-mini-cart-subtotal">' +
            "<span>Subtotal</span>" +
            '<span class="gemist-mini-cart-subtotal-value">$0.00</span>' +
          "</div>" +
          '<a class="gemist-mini-cart-checkout" href="' + window.Shopify.routes.root + 'checkout">Checkout</a>' +
          '<a class="gemist-mini-cart-view-cart" href="' + window.Shopify.routes.root + 'cart">View Bag</a>' +
        "</div>" +
      "</div>";

    document.body.appendChild(overlay);

    overlay.addEventListener("click", function(e) {
      if (e.target === overlay) gemistCloseMiniCart();
    });
    overlay.querySelector(".gemist-mini-cart-close").addEventListener("click", gemistCloseMiniCart);

    return overlay;
  }

  function openGemistMiniCart() {
    var overlay = document.getElementById("gemist-mini-cart-overlay") || gemistBuildMiniCartOverlay();

    fetch(window.Shopify.routes.root + "cart.js", {
      headers: { "Accept": "application/json" }
    })
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        gemistRenderMiniCart(overlay, cart);
        overlay.classList.add("is-open");
      })
      .catch(function(error) {
        console.error("[gemist] Failed to load cart for mini-cart", error);
        overlay.classList.add("is-open");
      });
  }

  window.onload = function() {

// Get the current URL of the parent page
    var url = window.location.href;

// Get the query string from the URL
    var queryString = url.split('?')[1];

// Create the iframe URL with the query string
    var iframeUrl = baseURL + "designer/engagement-ring?" + queryString;

// Set the iframe's source URL
    var iframe = document.getElementById("designer-iframe");

    iframe.src = iframeUrl;
  };

  window.addEventListener("message", function(event) {

    const designerIframe = document.getElementById("designer-iframe");

    if (event.data) {
      try {
        const message = JSON.parse(event.data);
        switch (message.type) {
          case "requestParentWindowHref":
            if (event.origin === gemistOrigin && designerIframe && designerIframe.contentWindow) {
              designerIframe.contentWindow.postMessage(window.location.href, gemistOrigin);
            }
            break;

          case "buy": {
            var rawRingId =
              message.ring && message.ring.variantId !== undefined
                ? message.ring.variantId
                : message.product &&
                  message.product.Shopify &&
                  message.product.Shopify.productVariant;

            var id;
            if (rawRingId === undefined || rawRingId === null) {
              id = undefined;
            } else if (typeof rawRingId === "number") {
              id = String(rawRingId);
            } else if (
              typeof rawRingId === "string" &&
              rawRingId.indexOf("/") !== -1
            ) {
              id = rawRingId.split("/").slice(-1)[0];
            } else {
              id = String(rawRingId);
            }

            var size = message.size;
            var ringItems = [];

            var product = {
              id: id,
              quantity: 1,
              properties: {
                Size: size
              }
            };

            var ring = message.ring || {};
            if (ring.band !== undefined) product.properties.Band = ring.band;
            if (ring.carat !== undefined) product.properties.Carat = ring.carat;
            if (ring.metal !== undefined) product.properties.Metal = ring.metal;
            if (ring.shape !== undefined) product.properties.Shape = ring.shape;
            if (ring.stone !== undefined) product.properties.Stone = ring.stone;
            if (ring.style !== undefined) product.properties.Style = ring.style;
            if (typeof message.image === "string" && message.image) product.properties._image_ring = message.image;

            if (message.engravingText != "") {
              var engraving = {
                id: "42630207930450",
                quantity: 1,
                properties: {
                  Text: message.engravingText,
                  Font: message.engravingFont
                }
              };

              ringItems.push(engraving);
            }

            if (message.hiddenGemstone && message.hiddenGemstone.variantId) {
              var rawHiddenGemstoneId = message.hiddenGemstone.variantId;
              var hiddenGemstoneId =
                typeof rawHiddenGemstoneId === "string" && rawHiddenGemstoneId.indexOf("/") !== -1
                  ? rawHiddenGemstoneId.split("/").slice(-1)[0]
                  : rawHiddenGemstoneId;
              var hiddenGemstone = {
                id: hiddenGemstoneId,
                quantity: 1,
                properties: {
                  Stone: message.hiddenGemstone.name
                }
              };
              if (typeof message.hiddenGemstoneImage === "string" && message.hiddenGemstoneImage) hiddenGemstone.properties._image_gemstone = message.hiddenGemstoneImage;

              ringItems.push(hiddenGemstone);
            }

            ringItems.push(product);

            if (!id) {
              designerIframe.contentWindow.postMessage(
                { type: "cart", status: "error", message: "No variant id" },
                "*"
              );
              break;
            }

            function isSoldOutError(data) {
              if (!data) return false;

              var text = [data.message, data.description]
                .filter(Boolean)
                .join(" ")
                .toLowerCase();

              return data.status === 422 && text.indexOf("already sold out") !== -1;
            }

            function wait(ms) {
              return new Promise(function(resolve) {
                setTimeout(resolve, ms);
              });
            }

            function addRingToCart(attempt) {
              var MAX_ATTEMPTS = 3; // 1 intento inicial + 2 reintentos

              return fetch(window.Shopify.routes.root + "cart/add.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  "X-Requested-With": "XMLHttpRequest",
                  "Accept": "application/json"
                },
                body: JSON.stringify({ items: ringItems })
              })
                .then(function(response) {
                  return response.json().then(function(data) {
                    return {
                      ok: response.ok,
                      data: data
                    };
                  });
                })
                .then(function(result) {
                  console.log("cart/add result", result, "attempt", attempt);

                  if (!result.ok) {
                    if (isSoldOutError(result.data) && attempt < MAX_ATTEMPTS) {
                      console.warn(
                        "Sold out error detected. Retrying in 3 seconds...",
                        "attempt",
                        attempt
                      );

                      return wait(3000).then(function() {
                        return addRingToCart(attempt + 1);
                      });
                    }

                    throw new Error(
                      result.data.description ||
                        result.data.message ||
                        "Add to cart failed"
                    );
                  }

                  return result;
                });
            }

            addRingToCart(1)
              .then(function(result) {
                if (message.diamond && message.diamond.variantId !== undefined) {
                  var diamondVariantId = message.diamond.variantId;
                  if (typeof diamondVariantId === "number")
                    diamondVariantId = String(diamondVariantId);
                  else if (typeof diamondVariantId === "string" && diamondVariantId.indexOf("/") !== -1)
                    diamondVariantId = diamondVariantId.split("/").slice(-1)[0];

                  var diamond = { id: diamondVariantId, quantity: 1, properties: {} };
                  if (typeof message.diamondImage === "string" && message.diamondImage) diamond.properties._image_diamond = message.diamondImage;

                  fetch(window.Shopify.routes.root + "cart/add.js", {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      "X-Requested-With": "XMLHttpRequest",
                      "Accept": "application/json"
                    },
                    body: JSON.stringify({ items: [diamond] })
                  })
                    .then(function(res) {
                      return res.json().then(function(d) { return { ok: res.ok, data: d }; });
                    })
                    .then(function(diamondResult) {
                      if (diamondResult.ok) {
                        designerIframe.contentWindow.postMessage(
                          {
                            type: "cart",
                            status: "added",
                            image_ring: message.image,
                            image_diamond: message.diamondImage,
                            image_gemstone: message.hiddenGemstoneImage
                          },
                          "*"
                        );
                        openGemistMiniCart();
                      } else {
                        var msg = (diamondResult.data && diamondResult.data.description)
                          ? diamondResult.data.description
                          : (diamondResult.data && diamondResult.data.message)
                            ? diamondResult.data.message
                            : "Diamond add failed";
                        designerIframe.contentWindow.postMessage(
                          { type: "cart", status: "error", message: msg },
                          "*"
                        );
                      }
                    })
                    .catch(function(error) {
                      console.error("Error al agregar el diamante:", error);
                      designerIframe.contentWindow.postMessage(
                        { type: "cart", status: "error", message: String(error && error.message ? error.message : error) },
                        "*"
                      );
                    });
                } else {
                  designerIframe.contentWindow.postMessage(
                    {
                      type: "cart",
                      status: "added",
                      image_ring: message.image,
                      image_diamond: message.diamondImage,
                      image_gemstone: message.hiddenGemstoneImage
                    },
                    "*"
                  );
                  openGemistMiniCart();
                }
              })
              .catch(function(error) {
                console.error("Error al agregar el anillo:", error);
                designerIframe.contentWindow.postMessage(
                  {
                    type: "cart",
                    status: "error",
                    message: String(error && error.message ? error.message : error)
                  },
                  "*"
                );
              });

            break;
          }
          case 'favorite':
            var {id} = message.product;

            fetch(baseURL + 'api/products/' + id + '/shmetadata')
            .then(response => response.json())
            .then(data => {
              var {productId, handle} = data;

              // create element to save
              var elementToSave = document.createElement('div');
              elementToSave.dataset.id = productId.split('/').slice(-1)[0];
              elementToSave.dataset.handle = handle;

              // use the saveWishlist function that we made available from theme.js
              saveWishlist($(elementToSave));
            })
            .catch((error) => {
                console.error('Error:', error);
            });
            break;
          case 'updateParams':
            // Get the parameter names from the message
            var paramNames = message.paramNames;
            var currentURL = new URL(window.location.href);

            // Loop through the parameter names
            paramNames.forEach(function(paramName) {
              // Retrieve the corresponding value from the message
              var paramValue = message[paramName];

              // Modify the query parameter of the parent URL with the value
              if (paramValue !== undefined) {
                currentURL.searchParams.set(paramName, paramValue);
              }
            });

            // Replace the parent URL with the modified URL
            window.history.replaceState({}, "", currentURL.toString());
            break;
          case 'download':
            const downloadHref = message.downloadHref;



            if (downloadHref) {
              window.open(downloadHref, "_blank");
            }
            break;
          case 'copywindowlocation':
            // Get the current window location
            var windowLocation = window.location.href;

            // Use the Clipboard API to copy the window location to the clipboard
            navigator.clipboard.writeText(windowLocation)
              .then(function() {
                console.log("Window location copied to clipboard successfully");
              })
              .catch(function(error) {
                console.error("Failed to copy window location to clipboard:", error);
              });
            break;
          case 'sendemail':
            let {emailContent, subject, recipient} = message;
            const currentPageLink = window.location.href;
            emailContent = emailContent.replace("{{currentPageLink}}", currentPageLink);

            const mailtoLink = `mailto:${recipient}?subject=${encodeURIComponent(
              subject
            )}&body=${encodeURIComponent(emailContent)}`;

            if (mailtoLink) {
              window.open(mailtoLink, "_blank");
            }
            break;
          case "requestfullscreen":
            (function () {
              var p = designerIframe.requestFullscreen ? designerIframe.requestFullscreen() : null;
              if (p && typeof p.then === "function") {
                p.then(postFullscreenStateToDesignerIframe).catch(function () {});
              }
            })();
            break;
          case "exitfullscreen":
            (function () {
              var p = null;
              if (document.exitFullscreen) {
                p = document.exitFullscreen();
              } else if (document.webkitExitFullscreen) {
                p = document.webkitExitFullscreen();
              } else if (document.mozCancelFullScreen) {
                p = document.mozCancelFullScreen();
              } else if (document.msExitFullscreen) {
                p = document.msExitFullscreen();
              }
              if (p && typeof p.then === "function") {
                p.then(postFullscreenStateToDesignerIframe).catch(function () {});
              }
            })();
            break;
          default:
            break;
        }
      } catch (e) { // console.log("Designer error", e);
      }
    }
  }, false);

  document.addEventListener("fullscreenchange", postFullscreenStateToDesignerIframe, false);
  document.addEventListener("webkitfullscreenchange", postFullscreenStateToDesignerIframe, false);
  document.addEventListener("mozfullscreenchange", postFullscreenStateToDesignerIframe, false);
  document.addEventListener("MSFullscreenChange", postFullscreenStateToDesignerIframe, false);


// This function sets the Designer's iframe's height by calculating the imperative elements (navbar, announcement bar) height,
// then subtracting their pixel values from the viewport's fullscreen space.
  document.addEventListener("DOMContentLoaded", function() {
    const isMobileDevice = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    const designerIFrameContainerElement = document.querySelector(".designer-iframe-container");
    const designerIFrameElement = document.querySelector("#designer-iframe");

    const selectorsToObserve = ['#shopify-section-header', '#shopify-section-banner', '#shopify-section-header-search'];
    const observedElements = document.querySelectorAll(selectorsToObserve.join(', '));

    const observer = new ResizeObserver(function(entries) {
      const totalHeight = entries.reduce((acc, entry) => acc + entry.contentRect.height, 0);

      if (designerIFrameContainerElement !== null && designerIFrameElement !== null && totalHeight) {
        const heightValueString = isMobileDevice
          ? `calc(100dvh - ${totalHeight}px)`
          : `calc(100vh - ${totalHeight}px)`;

        designerIFrameContainerElement.style.height = heightValueString;
        designerIFrameElement.style.height = heightValueString;
      }
    });
    observedElements.forEach(element => observer.observe(element));
  });


  } catch(e) { console.error(e); }
})();
})();
